//@flow

import React from 'react';
import { Col } from 'reactstrap';

import { WhitePanel } from '../../../../components';
import useFlightPageContext from '../../static-db';

const FlightPriceComparison = ({
  forMobile = false,
}: {
  forMobile: boolean,
}) => {
  const { valueProps: subTexts } = useFlightPageContext();

  return (
    <Col
      className={`col-lg-4 col-12 d-none ${
        forMobile ? 'd-lg-none' : 'd-lg-block'
      }`}
    >
      <WhitePanel className="other-price">
        <h3>
          Why Book through <br />
          <span>HoneyGuide</span>
        </h3>
        <ul className="spp">
          {subTexts.map(sT => (
            <li className="sub-text" key={sT}>
              {sT}
            </li>
          ))}
        </ul>
      </WhitePanel>
    </Col>
  );
};

export default React.memo(FlightPriceComparison);



// WEBPACK FOOTER //
// ./src/screens/Flights/SearchAndResults/StaticSections/FlightPriceComparison.js